import "%modules%/header/header";
import "%modules%/map/map";
import "%modules%/modal/modal";
import "%modules%/form/form";
import "%modules%/slider/slider";
import "%modules%/review/review";
